import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './product-tariff-override.reducer';

export const ProductTariffOverrideDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const productTariffOverrideEntity = useAppSelector(state => state.productTariffOverride.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="productTariffOverrideDetailsHeading">
          <Translate contentKey="crawlerBackendApp.productTariffOverride.detail.title">ProductTariffOverride</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{productTariffOverrideEntity.id}</dd>
          <dt>
            <span id="price">
              <Translate contentKey="crawlerBackendApp.productTariffOverride.price">Price</Translate>
            </span>
          </dt>
          <dd>{productTariffOverrideEntity.price}</dd>
          <dt>
            <Translate contentKey="crawlerBackendApp.productTariffOverride.product">Product</Translate>
          </dt>
          <dd>{productTariffOverrideEntity.product ? productTariffOverrideEntity.product.id : ''}</dd>
          <dt>
            <Translate contentKey="crawlerBackendApp.productTariffOverride.tariff">Tariff</Translate>
          </dt>
          <dd>{productTariffOverrideEntity.tariff ? productTariffOverrideEntity.tariff.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/product-tariff-override" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button
          tag={Link}
          to={`/product-tariff-override/${productTariffOverrideEntity.id}/edit`}
          replace
          color="primary"
        >
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default ProductTariffOverrideDetail;
